<template>
  <div class="control-box">
    <div class="control-box__inner">
      <el-upload
        v-loading="loading"
        :action="action"
        :headers="headers"
        :limit="max"
        :multiple="true"
        :before-upload="onBefore"
        :on-success="onSuccess"
        :on-error="onError"
        :show-file-list="false"
        :on-exceed="handleExceed"
        :auto-upload="true"
        list-type="picture"
        accept="image/*,video/*"
        :class="{ full: images.length >= max }"
        class="uploader uploader-images"
        ref="upload"
        drag
        name="file"
      >
        <div
          v-if="images.length < max"
          style="margin-right: 10px"
          class="el-upload__text"
        >
          Выберите файлы (изображения или видео)
        </div>
        <!-- <div class="el-upload__tip" slot="tip">
          <el-button size="small" type="success" @click="submitUpload"
            >Загрузить на сервер</el-button
          >
        </div> -->
        <!-- <div class="el-upload__tip" slot="tip">
          максимальное количество файлов - {{ max }}
        </div> -->
      </el-upload>

      <div v-if="images && images.length" class="gallery-list">
        <div v-for="(item, index) in images" :key="index" class="gallery-item">
          <div class="gallery-preview">
            <el-image
              v-if="item.type !== 'video'"
              :src="imageUrlFull(item.url || item)"
              :preview-src-list="imagePreviewList"
              fit="cover"
            />
            <div v-else class="gallery-video-icon">▶</div>
          </div>
          <div class="gallery-meta">
            <div class="gallery-index">#{{ index + 1 }}</div>
            <div class="gallery-actions">
              <el-button
                icon="el-icon-arrow-up"
                size="mini"
                @click="moveItem(index, index - 1)"
                :disabled="index === 0"
              />
              <el-button
                icon="el-icon-arrow-down"
                size="mini"
                @click="moveItem(index, index + 1)"
                :disabled="index === images.length - 1"
              />
              <el-button
                icon="el-icon-delete"
                size="mini"
                type="danger"
                @click="removeAt(index)"
              />
            </div>
          </div>
        </div>
      </div>

      <el-button
        v-show="images.length"
        @click="handleRemoveAll"
        class="delete"
        size="mini"
        type="danger"
        >Удалить элементы</el-button
      >
      <div class="external-url-box">
        <el-input
          v-model="externalUrl"
          size="mini"
          placeholder="Вставьте ссылку на видео"
          class="external-url-input"
        />
        <el-button
          size="mini"
          type="primary"
          class="external-url-button"
          @click="handleAddExternalUrl"
        >
          Добавить по ссылке
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
import defaultSettings from "@/settings";

const { baseApi } = defaultSettings;

export default {
  props: {
    value: {
      type: Array,
      required: false,
      default: () => [],
    },
    type: {
      type: String,
      required: false,
      default: "other",
    },
    max: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      loading: false,
      externalUrl: "",
    };
  },
  // created() {
  //   this.fileList = this.images.map((el) => {
  //     return {
  //       type: "image",
  //       url: this.imageUrlFull(el.url),
  //     };
  //   });
  // },
  mounted() {
    this.loading = false;
  },
  computed: {
    action() {
      return `${baseApi}/api/admin/files/`;
    },
    headers() {
      return {
        Authorization: `Bearer ${getToken()}`,
      };
    },
    images: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    videoPreviewUrl() {
      const svg =
        "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'>" +
        "<rect width='24' height='24' fill='%23ffffff'/>" +
        "<path d='M5 18H15C16.1046 18 17 17.1046 17 16V8.57143V8C17 6.89543 16.1046 6 15 6H5C3.89543 6 3 6.89543 3 8V16C3 17.1046 3.89543 18 5 18Z' stroke='%23000000' stroke-linecap='round' stroke-linejoin='round'/>" +
        "<circle cx='6.5' cy='9.5' r='0.5' stroke='%23000000' stroke-linejoin='round'/>" +
        "<path d='M17 10L21 7V17L17 14' stroke='%23000000' stroke-linejoin='round'/>" +
        "</svg>";
      return `data:image/svg+xml;utf8,${svg}`;
    },
    imagePreviewList() {
      return (this.images || [])
        .filter((item) => !this.imageItemIsVideo(item))
        .map((item) => this.imageUrlFull(item.url || item));
    },
  },
  watch: {},
  methods: {
    imageItemIsVideo(item) {
      if (item && typeof item.type === "string") {
        return item.type === "video";
      }
      return false;
    },
    imageUrlFull(url) {
      return url.includes("http") ? url : baseApi + url;
    },
    onBefore() {
      this.loading = true;
    },
    onError() {
      this.loading = false;
      this.images = [];
      this.$message({
        type: "error",
        message: "Ошибка при загрузке.",
      });
    },
    onSuccess(res, file) {
      this.loading = false;
      const isVideo =
        file && file.raw && typeof file.raw.type === "string"
          ? file.raw.type.startsWith("video/")
          : false;
      const mediaType = isVideo ? "video" : "image";
      this.images = [...this.images, { type: mediaType, url: res.url }];
    },
    submitUpload() {
      if (this.$refs.upload?.uploadFiles.length == this.images.length) return;
      this.loading = true;
      this.$refs.upload.submit();
    },

    handleRemoveAll() {
      this.$refs.upload.clearFiles();
      this.images = [];
    },
    handleExceed() {
      this.$message({
        message: "Максимальное количество изображений - " + this.max,
        type: "warning",
        duration: 1000,
      });
    },
    handleAddExternalUrl() {
      const url = (this.externalUrl || "").trim();
      if (!url) {
        this.$message({
          type: "warning",
          message: "Введите ссылку на видео.",
        });
        return;
      }

      this.images = [...(this.images || []), { type: "video", url }];
      this.externalUrl = "";
    },
    moveItem(from, to) {
      if (to < 0 || to >= this.images.length || from === to) return;
      const next = [...this.images];
      const [moved] = next.splice(from, 1);
      next.splice(to, 0, moved);
      this.images = next;
    },
    removeAt(index) {
      const next = [...this.images];
      next.splice(index, 1);
      this.images = next;
    },
  },
};
</script>

<style>
.uploader-image img {
  width: auto !important;
}
.full .el-upload-dragger {
  display: none;
}
</style>
<style scoped>
.external-url-box {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}
.external-url-input {
  flex: 1;
}
.external-url-button {
  white-space: nowrap;
}
.el-upload__text {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.control-box {
  display: flex;
  flex-direction: column;
}
.control-box__inner {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.delete {
  margin-top: 10px;
}
.size-box {
  height: 100%;
}
.uploader {
  display: inline-block;
}
.uploader-image {
  height: 100%;
  position: relative;
  min-width: 50px;
}
.uploader-image img {
  height: 100%;
  width: auto;
}
.uploader-image:hover .uploader-image__button {
  opacity: 1;
}
.uploader-image__button {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.5);
  opacity: 0;
  transition: 0.2s;
}
.uploader-image__button {
  pointer-events: none;
}
.uploader-image__button button {
  opacity: 0.8;
}
.uploader-button {
  margin-left: 20px;
  margin-right: 20px;
}

.uploader-button button {
  min-width: 90px;
}
</style>

<style>
.uploader.uploader-images .el-upload--picture-card {
  width: auto;
  height: auto;
  line-height: inherit;
  background: none;
  border: none;
}
.uploader .el-upload--picture-card i {
  font-size: 14px;
  color: #fff;
}

.img {
  width: 200px;
  height: 200px;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  margin-right: 10px;
}
.flex {
  display: flex;
  flex-wrap: wrap;
}

.uploader.uploader-images .el-upload-list {
  display: none;
}

.gallery-list {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.gallery-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.gallery-preview {
  width: 120px;
  height: 80px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
}

.gallery-preview img {
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
}

.gallery-video-icon {
  font-size: 32px;
}

.gallery-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
}

.gallery-index {
  font-weight: 500;
}

.gallery-actions {
  display: flex;
  gap: 4px;
}
</style>
